<script lang="ts">
	import { Label, Icon, Text } from '@Shelly/shelly-design-system';
	import type { DotsPropsTypes } from '@Shelly/shelly-design-system';
	import { mapIconToThin } from 'src/helpers/new-layout-helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	const SCROLL_DIRECTION_LEFT = 'L';
	const SCROLL_DIRECTION_RIGHT = 'R';
	const ICON_ARROW_UP = 'fas fa-arrow-up';
	const ICON_ARROW_DOWN = 'fas fa-arrow-down';
	const ICON_ARROW_LEFT = 'fas fa-arrow-left';
	const ICON_ARROW_RIGHT = 'fas fa-arrow-right';
	const ICON_ARROWS_UP_DOWN = 'fas fa-arrows-up-down';
	const ICON_ARROWS_LEFT_RIGHT = 'fas fa-arrows-left-right';
	const COLOR_PRIMARY = 'primary';
	const COLOR_DEFAULT = 'color-3';

	let className = '';
	export { className as class };

	export let rotationInput: {
		id?: number;
		ev?: string;
		last_ev?: string;
		last_ev_ts?: number;
		steps?: number;
	};
	export let color: DotsPropsTypes['color'] = 'default';
	export let isCompact: boolean = false;
	export let orientation: 'vertical' | 'horizontal' = 'vertical';
	export let alwaysShow = false;

	$: direction = rotationInput?.last_ev || rotationInput?.ev || '';
	$: steps = rotationInput?.steps || 0;
	$: isUp = direction === SCROLL_DIRECTION_LEFT;
	$: isDown = direction === SCROLL_DIRECTION_RIGHT;

	let icon = ICON_ARROWS_UP_DOWN;
	$: {
		if (orientation === 'horizontal') {
			if (isUp) {
				icon = ICON_ARROW_LEFT;
			} else if (isDown) {
				icon = ICON_ARROW_RIGHT;
			} else {
				icon = ICON_ARROWS_LEFT_RIGHT;
			}
		} else if (isUp) {
			icon = ICON_ARROW_UP;
		} else if (isDown) {
			icon = ICON_ARROW_DOWN;
		} else {
			icon = ICON_ARROWS_UP_DOWN;
		}
	}

	$: iconColor =
		color === COLOR_PRIMARY
			? `text-${COLOR_PRIMARY}`
			: $showNewLayout
				? ''
				: `text-${COLOR_DEFAULT}`;
</script>

{#if direction || alwaysShow}
	<div
		class="rotation-indicator {className}"
		class:rotation-indicator-horizontal={orientation === 'horizontal'}
	>
		<Icon {icon} size={isCompact ? 's' : 'm'} class="text-{iconColor}" />
		{#if steps > 0}
			<Label value={steps.toString()} class="text-{COLOR_DEFAULT}" size="xs" />
		{:else}
			<Label value={steps > 0 ? steps.toString() : '-'} class="text-{COLOR_DEFAULT}" size="xs" />
		{/if}
	</div>
{/if}

<style>
	.rotation-indicator {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 4px;
	}

	.rotation-indicator-horizontal {
		flex-direction: row;
	}
</style>
